(function () {
  'use strict';

  if (window.GGCartCore) return;

  var count = null;
  var syncingPromise = null;

  function formatMoney(cents) {
    if (typeof cents !== 'number' || Number.isNaN(cents)) return '';
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : undefined);
      }
    } catch (e) {}
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function updateBadgeNode(node, nextCount) {
    if (!node) return;
    var text = nextCount > 0 ? String(nextCount) : '';
    if (node.matches('[data-cart-count-value]')) node.setAttribute('data-cart-count-value', String(nextCount));
    if ('textContent' in node) node.textContent = text;
    if (nextCount > 0) {
      node.classList.remove('hidden', 'is-hidden', 'visually-hidden');
      node.hidden = false;
      node.setAttribute('aria-hidden', 'false');
    } else {
      if (node.matches('.gg-cart-live-badge,[data-mas-cart-count],.cart-bubble__text-count,[data-cart-count],[data-header-cart-count],[data-cart-count-number],#cart-bubble-text,#ggSidebarCartCount')) {
        node.classList.add('hidden');
      }
    }
  }

  function updateBadges(nextCount) {
    count = Number(nextCount) || 0;
    [
      '[data-mas-cart-count]',
      '.gg-cart-live-badge',
      '.cart-bubble__text-count',
      '[data-cart-count]',
      '[data-header-cart-count]',
      '[data-cart-count-number]',
      '#cart-bubble-text',
      '[data-cart-count-value]',
      '#ggSidebarCartCount',
      '[data-cart-item-count]',
      '.cart-count',
      '.cart__count',
      '.header__cart-count'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        updateBadgeNode(node, count);
      });
    });
    try {
      sessionStorage.setItem('gg_cart_count', String(count));
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch (e) {}
  }

  function notifyCart(cart, reason) {
    document.dispatchEvent(new CustomEvent('ggcart:updated', { bubbles: true, detail: { cart: cart, count: cart.item_count || 0, reason: reason || 'sync' } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, count: cart.item_count || 0 } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, count: cart.item_count || 0 } }));
    document.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true, detail: { data: { itemCount: cart.item_count || 0 } } }));
  }

  function sync(reason) {
    if (syncingPromise) return syncingPromise;
    syncingPromise = fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart sync failed');
        return response.json();
      })
      .then(function (cart) {
        updateBadges(cart.item_count || 0);
        notifyCart(cart, reason || 'sync');
        return cart;
      })
      .finally(function () {
        syncingPromise = null;
      });
    return syncingPromise;
  }

  function normalizeAddedItem(item, fallback) {
    fallback = fallback || {};
    return {
      title: item && (item.product_title || item.title) ? (item.product_title || item.title) : (fallback.title || 'Produit ajouté'),
      image: item && (item.image || (item.featured_image && item.featured_image.url) || item.featured_image) ? (item.image || (item.featured_image && item.featured_image.url) || item.featured_image) : (fallback.image || ''),
      price: item && typeof item.price === 'number' ? formatMoney(item.price) : (fallback.price || ''),
      subtitle: item && item.quantity > 1 ? 'Quantité : ' + item.quantity : (fallback.subtitle || 'Ajouté à votre panier')
    };
  }

  function addItem(variantId, quantity, fallbackDetail) {
    quantity = quantity || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function (item) {
        var detail = normalizeAddedItem(item, fallbackDetail);
        document.dispatchEvent(new CustomEvent('ggcart:item-added', { bubbles: true, detail: { item: item, drawer: detail } }));
        document.dispatchEvent(new CustomEvent('mas:open-drawer', { bubbles: true, detail: detail }));
        return sync('add').then(function (cart) {
          return { item: item, cart: cart, drawer: detail };
        });
      });
  }

  function installNetworkHooks() {
    if (window.__GG_CART_CORE_HOOKED__) return;
    window.__GG_CART_CORE_HOOKED__ = true;

    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function () {
        var request = arguments[0];
        var url = typeof request === 'string' ? request : (request && request.url) || '';
        return originalFetch.apply(this, arguments).then(function (response) {
          if (/\/cart\/(add|change|update|clear)(\.js)?/.test(String(url)) && response && response.ok) {
            setTimeout(function () { sync('network'); }, 0);
          }
          return response;
        });
      };
    }

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__ggCartUrl = url;
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(String(this.__ggCartUrl || ''))) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) setTimeout(function () { sync('xhr'); }, 0);
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  function restoreStoredCount() {
    try {
      var stored = JSON.parse(sessionStorage.getItem('cart-count') || 'null');
      if (stored && stored.value != null) updateBadges(parseInt(stored.value, 10) || 0);
    } catch (e) {}
  }

  window.GGCartCore = {
    sync: sync,
    addItem: addItem,
    getCount: function () { return count == null ? 0 : count; },
    updateBadges: updateBadges,
    formatMoney: formatMoney,
    cleanText: cleanText
  };

  restoreStoredCount();
  installNetworkHooks();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync('ready'); });
  } else {
    sync('ready');
  }

  window.addEventListener('pageshow', function () { sync('pageshow'); }, { capture: true });
  document.addEventListener('shopify:section:load', function () { sync('section'); });
})();
